import classNames from 'classnames';

export function Checkmark(props) {
    const {className} = props;

    const checkmarkClasses = classNames('check', 'icon', 'before', 'checkmark', className);

    return <span className={checkmarkClasses} />;
}
